<template>
    <div>
        <h3 v-if="label" class="mb-3">
            {{ label }}
        </h3>
        <v-autocomplete
            @change="handleSelect"
            :items="cities"
            :label="label"
            :item-text="'name'"
            :item-value="'id'"
            :rules="rules"
            :value="value"
            clearable
            outlined
            small
            dense
            multiple
        />
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import HAutocomplete from '@/components/app/HAutocomplete'
export default {
    name:"CitySelect",
    components: {
        HAutocomplete
    },
    props: {
        label: {
            type: String,
        },
        rules: {
            type: Array,
        },
        value: Array,
    },
data() {
        return {
            timer: null,
            cityLoading: false,
        }
    },
    computed: {
        ...mapGetters(['cities']),
    },

    methods: {
        ...mapActions(['fetchEnabledCitiesAdmin']),
        handleSelect(value) {
            this.$emit("input", value)
        },
    },
    mounted() {
        this.fetchEnabledCitiesAdmin()
    },
}
</script>